module.exports = __webpack_public_path__ + "img/theme13.e8bb0e7b.png";